
import loginRegisterModal from './loginRegisterModal';
import frozenRegistrationModal from './frozen-registration.modal';
import { obscuredLoginModal } from './obscured-login.modal';
export default {
  loginRegisterModal,
  frozenRegistrationModal,
  obscuredLoginModal
};
